module.exports = __webpack_public_path__ + "static/img/kg02.37f66ce.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/build08/assets/images/home/gamelist/kg02.png
// module id = DMjJ
// module chunks = 43